import { AKComponent } from "@theme/component";
import { VariantSelectedEvent, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { requestYieldCallback } from '@theme/utilities';
export default class VariantPicker extends AKComponent {
    /** @type {string | undefined} */
  #pendingRequestUrl;

  /** @type {AbortController | undefined} */
  #abortController;

    connectedCallback() {
        super.connectedCallback();
    
        this.addEventListener('change', (event) => this.variantChanged(event));
    }
      /**
   * Handles the variant change event.
   * @param {Event} event - The variant change event.
   */
    variantChanged(event) {
    // //console.log('variantChanged', event); 
    // usefull for debugging & secutity
    if (!(event.target instanceof HTMLElement)) {
        return;
      } 
      // get the selected option
      const selectedOption = event.target instanceof HTMLSelectElement ? event.target.options[event.target.selectedIndex] : event.target;
      if (!selectedOption) {
        return;
      }
      this.updateSelectedOption(event.target);
      this.dispatchEvent(new VariantSelectedEvent({ id: selectedOption.dataset.optionValueId ?? '' }));
      // @todo check with section product in HP 
      const isOnProductPage =
      this.dataset.templateProductMatch === 'true' &&
      !event.target.closest('product-card') &&
      !event.target.closest('quick-add-dialog');
    // //console.log('VariantPicker.variantChanged() - isOnProductPage:', isOnProductPage);

    const currentUrl = this.dataset.productUrl?.split('?')[0];
    const newUrl = selectedOption.dataset.connectedProductUrl;
    const loadsNewProduct = isOnProductPage && !!newUrl && newUrl !== currentUrl;
    // //console.log('VariantPicker.variantChanged() - newUrl:', {newUrl, currentUrl, isOnProductPage});
    // //console.log('VariantPicker.variantChanged() - loadsNewProduct:', loadsNewProduct);
    this.fetchUpdatedSection(this.buildRequestUrl(selectedOption), loadsNewProduct);

    const url = new URL(window.location.href);

    const variantId = selectedOption.dataset.variantId || null;
    // //console.log('variantId:', variantId);

        if (isOnProductPage) {
        // //console.log('VariantPicker.variantChanged() - isOnProductPage is true, updating URL params');
        if (variantId) {
            // //console.log('VariantPicker.variantChanged() - variantId exists, setting variant param:', variantId);
            url.searchParams.set('variant', variantId);
        } else {
            // //console.log('VariantPicker.variantChanged() - no variantId, deleting variant param');
            url.searchParams.delete('variant');
        }
        } else {
        // //console.log('VariantPicker.variantChanged() - not on product page, skipping URL param update');
        }

        // Change the path if the option is connected to another product via combined listing.
        if (loadsNewProduct) {
        // //console.log('VariantPicker.variantChanged() - loadsNewProduct is true, changing pathname to:', newUrl);
        url.pathname = newUrl;
        } else {
        // //console.log('VariantPicker.variantChanged() - loadsNewProduct is false, keeping current pathname');
        }

        if (url.href !== window.location.href) {
        // //console.log('VariantPicker.variantChanged() - URL changed, updating history');
        requestYieldCallback(() => {
            history.replaceState({}, '', url.toString());
        });
        } else {
        // //console.log('VariantPicker.variantChanged() - URL unchanged, no history update needed');
        }
    }
    /**
   * Updates the selected option.
   * @param {string | Element} target - The target element.
   */
    updateSelectedOption(target) {
        if (typeof target === 'string') {
          const targetElement = this.querySelector(`[data-option-value-id="${target}"]`);
    
          if (!targetElement) throw new Error('Target element not found');
    
          target = targetElement;
        }
        // //console.log('target', target);
        // //console.log('target instanceof HTMLInputElement', target instanceof HTMLInputElement);
        
        if (target instanceof HTMLInputElement) {
          target.checked = true;
        }
    
        if (target instanceof HTMLSelectElement) {
          const newValue = target.value;
          const newSelectedOption = Array.from(target.options).find((option) => option.value === newValue);
    
          if (!newSelectedOption) throw new Error('Option not found');
    
          for (const option of target.options) {
            option.removeAttribute('selected');
          }
    
          newSelectedOption.setAttribute('selected', 'selected');
        }
    }

    /**
   * Builds the request URL.
   * @param {HTMLElement} selectedOption - The selected option.
   * @param {string | null} [source] - The source.
   * @param {string[]} [sourceSelectedOptionsValues] - The source selected options values.
   * @returns {string} The request URL.
   */
  buildRequestUrl(selectedOption, source = null, sourceSelectedOptionsValues = []) {
    // //console.log('VariantPicker.buildRequestUrl()', { selectedOption, source, sourceSelectedOptionsValues });
    // this productUrl and pendingRequestUrl will be useful for the support of combined listing. It is used when a user changes variant quickly and those products are using separate URLs (combined listing).
    // We create a new URL and abort the previous fetch request if it's still pending.
    let productUrl = selectedOption.dataset.connectedProductUrl || this.#pendingRequestUrl || this.dataset.productUrl;
    this.#pendingRequestUrl = productUrl;
    const params = [];

    if (this.selectedOptionsValues.length && !source) {
      // //console.log('VariantPicker.buildRequestUrl() - adding option_values from selectedOptionsValues');
      params.push(`option_values=${this.selectedOptionsValues.join(',')}`);
    } else if (source === 'product-card') {
      // //console.log('VariantPicker.buildRequestUrl() - source is product-card');
      if (this.selectedOptionsValues.length) {
        // //console.log('VariantPicker.buildRequestUrl() - using sourceSelectedOptionsValues');
        params.push(`option_values=${sourceSelectedOptionsValues.join(',')}`);
      } else {
        // //console.log('VariantPicker.buildRequestUrl() - using selectedOption optionValueId');
        params.push(`option_values=${selectedOption.dataset.optionValueId}`);
      }
    } else {
      // //console.log('VariantPicker.buildRequestUrl() - no params to add');
    }

    // If variant-picker is a child of quick-add-component or swatches-variant-picker-component, we need to append section_id=section-rendering-product-card to the URL
    if (this.closest('quick-add-component') || this.closest('swatches-variant-picker-component')) {
      // //console.log('VariantPicker.buildRequestUrl() - variant-picker is child of quick-add or swatches component');
      if (productUrl?.includes('?')) {
        // //console.log('VariantPicker.buildRequestUrl() - productUrl contains ?, removing query params');
        productUrl = productUrl.split('?')[0];
      }
      const resultUrl = `${productUrl}?section_id=section-rendering-product-card&${params.join('&')}`;
      // //console.log('VariantPicker.buildRequestUrl() - returning URL with section_id:', resultUrl);
      return resultUrl;
    }
    const resultUrl = `${productUrl}?${params.join('&')}`;
    // //console.log('VariantPicker.buildRequestUrl() - returning standard URL:', resultUrl);
    return resultUrl;
  }
     /**
   * Fetches the updated section.
   * @param {string} requestUrl - The request URL.
   * @param {boolean} shouldMorphMain - If the entire main content should be morphed. By default, only the variant picker is morphed.
   */
  fetchUpdatedSection(requestUrl, shouldMorphMain = false) {
    // //console.log('VariantPicker.fetchUpdatedSection()', { requestUrl, shouldMorphMain });
    // We use this to abort the previous fetch request if it's still pending.
    this.#abortController?.abort();
    this.#abortController = new AbortController();

    fetch(requestUrl, { signal: this.#abortController.signal })
      .then((response) => response.text())
      .then((responseText) => {
        // //console.log('VariantPicker.fetchUpdatedSection() - fetch response received');
        this.#pendingRequestUrl = undefined;
        const html = new DOMParser().parseFromString(responseText, 'text/html');

        const textContent = html.querySelector(`variant-picker script[type="application/json"]`)?.textContent;
        if (!textContent) {
          // //console.log('VariantPicker.fetchUpdatedSection() - no textContent found, returning');
          return;
        }
        // //console.log('VariantPicker.fetchUpdatedSection() - textContent found, continuing :', {shouldMorphMain,html, textContent});
        if (shouldMorphMain) {
          // //console.log('VariantPicker.fetchUpdatedSection() - shouldMorphMain is true, updating main');
          this.updateMain(html);
        } else {
          // //console.log('VariantPicker.fetchUpdatedSection() - shouldMorphMain is false, updating variant picker');
          const newProduct = this.updateVariantPicker(html);
          
          // We grab the variant object from the response and dispatch an event with it.
          if (this.selectedOptionId) {
            // //console.log('VariantPicker.fetchUpdatedSection() - selectedOptionId exists, dispatching VariantUpdateEvent');
            this.dispatchEvent(
              new VariantUpdateEvent(JSON.parse(textContent), this.selectedOptionId, {
                html,
                productId: this.dataset.productId ?? '',
                newProduct,
              })
            );
             // Mettre à jour les blocs avec data-to_upd si on est sur une page produit
          this.#updateBlocksWithDataToUpd(html);
          } else {
            // //console.log('VariantPicker.fetchUpdatedSection() - no selectedOptionId, skipping event dispatch');
          }
        }
      })
      .catch((error) => {
        if (error.name === 'AbortError') {
          // //console.log('VariantPicker.fetchUpdatedSection() - fetch aborted by user');
          console.warn('Fetch aborted by user');
        } else {
          // //console.log('VariantPicker.fetchUpdatedSection() - fetch error:', error);
          console.error(error);
        }
      });
  }

   /**
   * Gets the selected options values.
   * @returns {string[]} The selected options values.
   */
   get selectedOptionsValues() {
    // //console.log('VariantPicker.selectedOptionsValues getter called');
    /** @type HTMLElement[] */
    const selectedOptions = Array.from(this.querySelectorAll('select option[selected], fieldset input:checked'));
    // //console.log('VariantPicker.selectedOptionsValues - found selectedOptions:', selectedOptions);

    return selectedOptions.map((option) => {
      const { optionValueId } = option.dataset;

      if (!optionValueId) {
        // //console.log('VariantPicker.selectedOptionsValues - no optionValueId found for option, throwing error');
        throw new Error('No option value ID found');
      }
      // //console.log('VariantPicker.selectedOptionsValues - optionValueId found:', optionValueId);

      return optionValueId;
    });
  }
   /**
   * Gets the selected option ID.
   * @returns {string | undefined} The selected option ID.
   */
   get selectedOptionId() {
    // //console.log('VariantPicker.selectedOptionId getter called');
    const { selectedOption } = this;
    // //console.log('VariantPicker.selectedOptionId - selectedOption:', selectedOption);
    if (!selectedOption) {
      // //console.log('VariantPicker.selectedOptionId - no selectedOption, returning undefined');
      return undefined;
    }
    // //console.log('VariantPicker.selectedOptionId - selectedOption found');
    const { optionValueId } = selectedOption.dataset;

    if (!optionValueId) {
      // //console.log('VariantPicker.selectedOptionId - no optionValueId found, throwing error');
      throw new Error('No option value ID found');
    }
    // //console.log('VariantPicker.selectedOptionId - optionValueId found:', optionValueId);

    return optionValueId;
  }

    /**
   * Gets the selected option.
   * @returns {HTMLInputElement | HTMLOptionElement | undefined} The selected option.
   */
    get selectedOption() {
        // //console.log('VariantPicker.selectedOption getter called');
        const selectedOption = this.querySelector('select option[selected], fieldset input:checked');
    
        if (!(selectedOption instanceof HTMLInputElement || selectedOption instanceof HTMLOptionElement)) {
          // //console.log('VariantPicker.selectedOption - selectedOption is not HTMLInputElement or HTMLOptionElement, returning undefined');
          return undefined;
        }
        // //console.log('VariantPicker.selectedOption - selectedOption found:', selectedOption);
    
        return selectedOption;
    }

  /**
   * Re-renders the variant picker.
   * @param {Document} newHtml - The new HTML.
   * @returns {NewProduct | undefined} Information about the new product if it has changed, otherwise undefined.
   */
  updateVariantPicker(newHtml) {
    // //console.log('VariantPicker.updateVariantPicker()', { newHtml });
    /** @type {NewProduct | undefined} */
    let newProduct;

    const newVariantPickerSource = newHtml.querySelector(this.tagName.toLowerCase());

    if (!newVariantPickerSource) {
      // //console.log('VariantPicker.updateVariantPicker() - no new variant picker source found, throwing error');
      throw new Error('No new variant picker source found');
    }
    // //console.log('VariantPicker.updateVariantPicker() - new variant picker source found');

    // For combined listings, the product might have changed, so update the related data attribute.
    if (newVariantPickerSource instanceof HTMLElement) {
      // //console.log('VariantPicker.updateVariantPicker() - newVariantPickerSource is HTMLElement');
      const newProductId = newVariantPickerSource.dataset.productId;
      const newProductUrl = newVariantPickerSource.dataset.productUrl;

      if (newProductId && newProductUrl && this.dataset.productId !== newProductId) {
        // //console.log('VariantPicker.updateVariantPicker() - product changed, creating newProduct object');
        newProduct = { id: newProductId, url: newProductUrl };
      } else {
        // //console.log('VariantPicker.updateVariantPicker() - product unchanged or missing data');
      }

      this.dataset.productId = newProductId;
      this.dataset.productUrl = newProductUrl;
    } else {
      // //console.log('VariantPicker.updateVariantPicker() - newVariantPickerSource is not HTMLElement');
    }

    // //console.log('VariantPicker.updateVariantPicker() - calling morph - newVariantPickerSource ',{newVariantPickerSource});
    morph(this, newVariantPickerSource);

    // //console.log('VariantPicker.updateVariantPicker() - returning newProduct:', newProduct);
    return newProduct;
  }

   /**
   * Re-renders the entire main content.
   * @param {Document} newHtml - The new HTML.
   */
   updateMain(newHtml) {
   
    const main = document.querySelector('main');
    const newMain = newHtml.querySelector('main');

    if (!main || !newMain) {
      
      throw new Error('No new main source found');
    }
    

    morph(main, newMain);
  }

  /**
   * Updates blocks with data-to_upd attribute if content is different
   * @param {Document} newHtml - The new HTML document from the variant update
   */
  #updateBlocksWithDataToUpd(newHtml) {
    const elementsToUpdate = document.querySelectorAll('[data-to_upd]');
    
    // Vérifier l'unicité des data-to_upd
    const blockIds = new Set();
    const duplicateIds = new Set();
    
    elementsToUpdate.forEach(element => {
      const blockId = element.getAttribute('data-to_upd');
      if (blockId) {
        if (blockIds.has(blockId)) {
          duplicateIds.add(blockId);
          console.warn(`Duplicate data-to_upd="${blockId}" found. Each data-to_upd must be unique.`);
        } else {
          blockIds.add(blockId);
        }
      }
    });
    
    // Traiter seulement les éléments avec des IDs uniques
    elementsToUpdate.forEach(element => {
      const blockId = element.getAttribute('data-to_upd');
      if (blockId && !duplicateIds.has(blockId)) {
        // Conversion explicite de Element en HTMLElement pour satisfaire le typage strict
        this.#updateBlockIfDifferent(element instanceof HTMLElement ? element : /** @type {HTMLElement} */(element), blockId, newHtml);
      }
    });
  }

  /**
   * Updates a block only if the content is different
   * @param {HTMLElement} currentElement - The current element to update
   * @param {string} blockId - The block ID
   * @param {Document} newHtml - The new HTML document
   */
  #updateBlockIfDifferent(currentElement, blockId, newHtml) {
    const newElement = newHtml.querySelector(`[data-to_upd="${blockId}"]`);
    
    if (!newElement) {
      // Si l'élément n'existe pas dans la nouvelle réponse, on le supprime
      currentElement.remove();
      return;
    }

    // Comparer le contenu textuel
    const currentContent = currentElement.textContent?.trim();
    const newContent = newElement.textContent?.trim();
    
    if (currentContent !== newContent) {
      morph(currentElement, newElement);
    }
  }

}

if (!customElements.get('variant-picker')) {
  customElements.define('variant-picker', VariantPicker);
}